export var REQUIRED_ERROR = "This field is required.";
export var fieldRequired = function fieldRequired(value) {
  return !value || Array.isArray(value) && !value.length ? REQUIRED_ERROR : undefined;
};